<template>
<div class="">
<beginExercise :CelotnaNaloga="exerciseVersion"></beginExercise>
      <template v-for="(uprasanje, index) in exerciseVersion.questions">
        <!-- vprasanje celotne naloge -->
        <div :key="index"> <!--v-if="exerciseVersion.parent == null"-->
          <numeric v-if="uprasanje.type.toLowerCase() == 'numerical'" :key="uprasanje.guid" :uniqueKey="nameOfQuestion + getUniqueKey()" :CelotnoVprasanje="uprasanje" :exerciseVersionId="exerciseVersion.exerciseVersionId" :scoringSettings="exerciseVersion.scoringSettings" :showAnswer="showAnswer" :identifier="getIdentifier()" :parent="exerciseVersion.parent" :index="index"></numeric>
          <radio v-if="uprasanje.type.toLowerCase() == 'radio'" :key="uprasanje.guid" :uniqueKey="nameOfQuestion + getUniqueKey()" :CelotnoVprasanje="uprasanje" :exerciseVersionId="exerciseVersion.exerciseVersionId" :scoringSettings="exerciseVersion.scoringSettings" :showAnswer="showAnswer" :identifier="getIdentifier()" :parent="exerciseVersion.parent" :index="index" ></radio>
          <essay v-if="uprasanje.type.toLowerCase() == 'essay'" :key="uprasanje.guid" :uniqueKey="nameOfQuestion + getUniqueKey()" :CelotnoVprasanje="uprasanje" :exerciseVersionId="exerciseVersion.exerciseVersionId" :scoringSettings="exerciseVersion.scoringSettings" :showAnswer="showAnswer" :identifier="getIdentifier()" :parent="exerciseVersion.parent" :index="index"></essay>
          <multichoice v-if="uprasanje.type.toLowerCase() == 'multichoice'" :key="uprasanje.guid" :uniqueKey="nameOfQuestion + getUniqueKey()" :CelotnoVprasanje="uprasanje" :exerciseVersionId="exerciseVersion.exerciseVersionId" :scoringSettings="exerciseVersion.scoringSettings" :showAnswer="showAnswer" :identifier="getIdentifier()" :parent="exerciseVersion.parent" :index="index"></multichoice>
          <slider v-if="uprasanje.type.toLowerCase() == 'slider'" :key="uprasanje.guid" :uniqueKey="nameOfQuestion + getUniqueKey()" :CelotnoVprasanje="uprasanje" :exerciseVersionId="exerciseVersion.exerciseVersionId" :scoringSettings="exerciseVersion.scoringSettings" :showAnswer="showAnswer" :identifier="getIdentifier()" :parent="exerciseVersion.parent" :index="index"></slider>
          <crypto v-if="uprasanje.type.toLowerCase() == 'crypto'" :key="uprasanje.guid" :uniqueKey="nameOfQuestion + getUniqueKey()" :CelotnoVprasanje="uprasanje" :exerciseVersionId="exerciseVersion.exerciseVersionId" :scoringSettings="exerciseVersion.scoringSettings" :showAnswer="showAnswer" :identifier="getIdentifier()" :parent="exerciseVersion.parent" :index="index"></crypto>
        </div>
        <!-- Mogu da prosledim koji je rodjitelj celog zadatka svakom od pitanja, pa onda u pitanju da se macujem sa tim kako da dobijem roditelja i odgovarajuce resenje sa njim
        <div :key="index" v-else>
          <numeric v-if="uprasanje.type.toLowerCase() == 'numerical'" :key="uprasanje.guid" :uniqueKey="nameOfQuestion + getUniqueKey()" :CelotnoVprasanje="uprasanje" :exerciseVersionId="exerciseVersion.exerciseVersionId" :scoringSettings="exerciseVersion.scoringSettings" :showAnswer="showAnswer" :parent="CelotnaNalogaParent" :index="index"></numeric>
          <radio v-if="uprasanje.type.toLowerCase() == 'radio'" :key="uprasanje.guid" :uniqueKey="nameOfQuestion + getUniqueKey()" :CelotnoVprasanje="uprasanje" :exerciseVersionId="exerciseVersion.exerciseVersionId" :scoringSettings="exerciseVersion.scoringSettings" :showAnswer="showAnswer" :parent="CelotnaNalogaParent" :index="index"></radio>
          <essay v-if="uprasanje.type.toLowerCase() == 'essay'" :key="uprasanje.guid" :uniqueKey="nameOfQuestion + getUniqueKey()" :CelotnoVprasanje="uprasanje" :exerciseVersionId="exerciseVersion.exerciseVersionId" :scoringSettings="exerciseVersion.scoringSettings" :showAnswer="showAnswer" :parent="CelotnaNalogaParent" :index="index"></essay>
          <multichoice v-if="uprasanje.type.toLowerCase() == 'multichoice'" :key="uprasanje.guid" :uniqueKey="nameOfQuestion + getUniqueKey()" :CelotnoVprasanje="uprasanje" :exerciseVersionId="exerciseVersion.exerciseVersionId" :scoringSettings="exerciseVersion.scoringSettings" :showAnswer="showAnswer" :parent="CelotnaNalogaParent" :index="index"></multichoice>
          <slider v-if="uprasanje.type.toLowerCase() == 'slider'" :key="uprasanje.guid" :uniqueKey="nameOfQuestion + getUniqueKey()" :CelotnoVprasanje="uprasanje" :exerciseVersionId="exerciseVersion.exerciseVersionId" :scoringSettings="exerciseVersion.scoringSettings" :showAnswer="showAnswer" :parent="CelotnaNalogaParent" :index="index"></slider>
        </div> -->
      </template>
</div>
</template>

<script>
import Numeric from '@/components/exercises/types/Numeric.vue'
import Radio from '@/components/exercises/types/Radio.vue'
import Multichoice from '@/components/exercises/types/Multichoice.vue'
import Likert from '@/components/exercises/types/Likert.vue'
import Essay from '@/components/exercises/types/Essay.vue'
import BeginExercise from '@/components/exercises/ExerciseTitle.vue'
import Slider from '@/components/exercises/types/Slider.vue'
import CryptoExercise from '@/components/exercises/types/Crypto.vue'

let crypto = require('crypto')
export default {
  data () {
    return {
      nameOfQuestion: 'question-',
      exerciseVersion: {},
      CelotnaNalogaParent: {}
    }
  },
  props: {
    showAnswer: {
      type: Boolean
    },
    subgroupExercise: {
      type: Object
    },
    bareBonesExercise: {
      type: Object
    },
    examExercise: {
      type: Object
    }
  },
  methods: {
    getUniqueKey () { // async?
      let generated = crypto.randomBytes(20).toString('hex')
      while (window.jQuery(this.nameOfQuestion + generated) == null) {
        generated = crypto.randomBytes(20).toString('hex')
      }
      return generated
    },
    evalProps () {
      if (this.subgroupExercise) this.exerciseVersion = this.subgroupExercise.exercise.version
      if (this.bareBonesExercise) this.exerciseVersion = this.bareBonesExercise
      if (this.examExercise) this.exerciseVersion = this.examExercise
    },
    getIdentifier () {
      if (this.examExercise) return this.exerciseVersion.id
      if (this.subgroupExercise) return this.exerciseVersion.identifier
    }
  },
  watch: {
    'bareBonesExercise': {
      handler: function (val, oldVal) {
        this.evalProps()
      },
      deep: true
    }
  },
  components: {
    'numeric': Numeric,
    'radio': Radio,
    'multichoice': Multichoice,
    'likert': Likert,
    'essay': Essay,
    'beginExercise': BeginExercise,
    'slider': Slider,
    'crypto': CryptoExercise
  },
  mounted () {
    this.evalProps()
  }
}
</script>
<style>
.exercise-footer button {
  padding-left: 2em;
  padding-right: 2em;
  margin: 1ex;
}
.exercise-item .time {
  float: right;
}
.exercise-header {
  margin-bottom: 1em;
}

.enum {
  counter-reset: item;
}

.enum > li {
  display: table;
  counter-increment: item;
}

.enum > li:before {
  content: counters(item, ".") ". ";
  display: table-cell;
}

.enum_alph {
  counter-reset: list;
}
.enum_alph > li {
  list-style: none;
}
.enum_alph > li:before {
  content: counter(list, lower-alpha) ") ";
  counter-increment: list;
}

.bober-img {
  width: auto;
  height: auto;
  max-width: 90%;
  max-height: 90%;
  margin: 20px;
}

.bober-table td {
  padding: 5px;
}

</style>



// WEBPACK FOOTER //
// Exercise.vue?c06ae2f2